// import external modules
import React, { Component } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import Router from "./router";
import cookie from 'js-cookie'
import { withRouter  } from 'react-router-dom'
class App extends Component {
    componentWillMount() {
        let token = cookie.get('token')
        if (!token) {
            const { history, location } = this.props
            if (location.pathname === "/") {
                history.replace("/login");
            } else if (location.pathname !== '/privacy-policy') {
                history.replace(`${location.pathname}`)
            }
        }
    }

    render() {
        return (
            <Router />
        )
    }
}

export default withRouter(App);
